import type { AcuityEffectiveScore } from "@/core/types";
import { AcuityScoreBadge } from "@/features/acuity/components/AcuityScoreBadge";
import { cn } from "@/lib/helpers/cn";

import { getFormattedAcuityDate } from "../helpers/getFormattedAcuityDate";

export type CurrentAcuityScoreProps = Pick<AcuityEffectiveScore, "score" | "resolved_at">;

export function CurrentAcuityScore({ resolved_at, score }: CurrentAcuityScoreProps) {
  const formattedDate = resolved_at ? getFormattedAcuityDate(resolved_at) : undefined;

  return (
    <section
      className={cn(
        "tw:flex tw:flex-col tw:justify-center tw:gap-1.25",
        "tw:rounded-sm tw:border tw:border-solid tw:border-stroke-tertiary",
        "tw:h-25 tw:bg-fill-white tw:px-4",
      )}
    >
      <h3 className="tw:mb-0! tw:text-sm! tw:font-bold! tw:text-text-primary">
        Current Acuity Index:
      </h3>

      <AcuityScoreBadge acuityScore={score} className="tw:m-0 tw:self-baseline" />

      <span className="body-xs tw:text-text-tertiary">
        Updated: <time dateTime={resolved_at}>{formattedDate}</time>
      </span>
    </section>
  );
}
